import { AccordionSize, AccordionVariant } from "./types";

export const DEFAULT_ACCORDION_SIZE: AccordionSize = "large";
export const DEFAULT_ACCORDION_VARIANT: AccordionVariant = "outlined";
